// 目前的功能是在原基础上修改，目前只支持记住一个密码，且函数的命名还可以优化
import Crypto from './Crypto.js'
import { getPublicKey } from './Common.js'

export default class RememberPassword extends Crypto {
  constructor () {
    super()
    this.account = ''
    this.accountList = []
    this.password = ''
    this.passwordArr = []
    this.passwordObj = {}
  }
  // 获取密码
  getPassword (account) {
    this.account = account
    this.passwordArr = JSON.parse(localStorage.getItem('passwords'))
    if (!this.passwordArr || this.passwordArr.length === 0) {
      localStorage.setItem('passwords', JSON.stringify([]))
      this.passwordArr = []
    } else {
      this._getAccountAndPassword()
      this._getAccountList()
      this._transferArrToObj()
    }
    return this.password
  }
  // 存储密码
  savePassword (account, password, rememberpw) {
    this._deleteAccountAndPassword() // 保存信息先去重
    let publicKey = getPublicKey(account)
    let md5 = super.getMD5(publicKey)
    let passwordObj = {}
    if (rememberpw) {
      passwordObj[account] = super.aesEncrypt(md5, password)
    } else {
      passwordObj[account] = ''
    }
    this.passwordArr = []
    this.passwordArr.push(passwordObj)
    localStorage.setItem('passwords', JSON.stringify(this.passwordArr))
  }
  // 获取登录信息
  _getAccountAndPassword () {
    let arr = this.passwordArr[this.passwordArr.length - 1]
    // this.account = Object.keys(arr)[0]
    let publicKey = getPublicKey(this.account)
    let md5 = super.getMD5(publicKey)
    this.password = super.aesDecrypt(md5, Object.values(arr)[0])
  }
  // 删除登录信息
  _deleteAccountAndPassword () {
    for (let i in this.passwordArr) {
      if (this.account === Object.keys(this.passwordArr[i])[0]) {
        this.passwordArr.splice(i, 1)
        break
      }
    }
  }
  // 获取登录账号列表
  _getAccountList () {
    this.passwordArr.forEach((item) => {
      this.accountList.push(Object.keys(item)[0])
    })
  }
  // 将密码数组转换为对象
  _transferArrToObj () {
    for (let i in this.passwordArr) {
      this.passwordObj[Object.keys(this.passwordArr[i])[0]] = Object.values(this.passwordArr[i])[0]
    }
  }
}



// WEBPACK FOOTER //
// ./src/new-login-2018/common/RememberPassword.js